// Utilitaires pour la page RoomPageV2

export const formatDate = (timestamp) => {
  if (!timestamp) return "N/A";
  const date = new Date(timestamp);
  return date.toLocaleString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDateOnly = (timestamp) => {
  if (!timestamp) return "N/A";
  const date = new Date(timestamp);
  return date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const formatTime = (timestamp) => {
  if (!timestamp) return "N/A";
  const date = new Date(timestamp);
  return date.toLocaleTimeString("fr-FR", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatTemperature = (temp) => {
  if (!temp) return "N/A";
  return `${temp}°C`;
};

export const formatVolume = (volume) => {
  if (!volume) return "N/A";
  return `${volume}L`;
};

export const getBatteryLevelColor = (level) => {
  if (!level) return "bg-gray-100 text-gray-800";

  const batteryLevel = parseInt(level);
  if (batteryLevel >= 80) return "bg-green-100 text-green-800";
  if (batteryLevel >= 50) return "bg-yellow-100 text-yellow-800";
  if (batteryLevel >= 20) return "bg-orange-100 text-orange-800";
  return "bg-red-100 text-red-800";
};

export const getInteractionTypeColor = (interaction) => {
  switch (interaction) {
    case "COMPLETED":
      return "bg-green-100 text-green-800";
    case "INTERRUPTED":
      return "bg-red-100 text-red-800";
    case "ONGOING":
      return "bg-blue-100 text-blue-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};
